module.exports = __webpack_public_path__ + "../resources/img/weather_rain.374f523f.svg";